import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { ButtonCancel, ButtonEdit, ButtonSave, Label, StyledInput } from './EditableLabel.style'

const EditableLabel = ({ blocked, children, className, onCancel, onSubmit, value: initialValue }) => {
    const [isEditing, setIsEditing] = useState(false)
    const [value, setValue] = useState('')
    const inputRef = useRef(null)

    useEffect(() => {
        if (isEditing) {
            inputRef.current.focus()
        }
    }, [isEditing])

    // Check if specified value changes
    useEffect(() => {
        if (initialValue) {
            setValue(initialValue)
        } else if (typeof children === 'string') {
            setValue(children)
        }
    }, [initialValue, children])

    /**
     * Toggle `isEditing` value
     */
    const toggleEdit = () => setIsEditing(!isEditing)

    /**
     * On cancel callback
     */
    const onCancelClick = () => {
        setIsEditing(false)

        if (typeof onCancel === 'function') {
            onCancel()
        }
    }

    // On submit callback
    const onSubmitClick = () => {
        setIsEditing(false)

        if (typeof onSubmit === 'function') {
            onSubmit(value)
        }
    }

    return (
        <>
            {!blocked && isEditing && (
                <span className={className}>
                    <StyledInput
                        ref={inputRef}
                        size="none"
                        type="text"
                        value={value}
                        onChange={({ target: { value: newValue } }) => setValue(newValue)}
                        onKeyPress={({ key }) => {
                            if (key === 'Enter') {
                                onSubmitClick()
                            }
                        }}
                    />
                    <ButtonSave theme="light" onClick={onSubmitClick}>
                        <FontAwesomeIcon icon="check" />
                    </ButtonSave>
                    <ButtonCancel theme="light" onClick={onCancelClick}>
                        <FontAwesomeIcon icon="times" />
                    </ButtonCancel>
                </span>
            )}
            {(blocked || !isEditing) && (
                <Label onClick={blocked ? null : toggleEdit} onKeyPress={() => null} role="button" tabIndex="0">
                    {children}
                    {!blocked && (
                        <ButtonEdit theme="light" onClick={() => setIsEditing(true)}>
                            <FontAwesomeIcon icon="edit" />
                        </ButtonEdit>
                    )}
                </Label>
            )}
        </>
    )
}

EditableLabel.propTypes = {
    blocked: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    value: PropTypes.string,
}

EditableLabel.defaultProps = {
    blocked: false,
    children: null,
    className: null,
    onCancel: () => null,
    onSubmit: () => null,
    value: null,
}

export default EditableLabel
